.IOPanel {
    display: flex;
    align-items: center;
    gap: 40px;
}

.IOPanel__divider {
    width: 1px;
    align-self: stretch;
    background: var(--soniq-t--global--border--color--column--default);
}
